import RessourcesPage from './RessourcesPage';
export default RessourcesPage